const mapping: { [index: string]: string } = {
  bookingModal: 'NewModal--bookingModal',
  form: 'NewModal--form',
  printable: 'NewModal--printable',
  skinny: 'NewModal--skinny',
  tiny: 'NewModal--tiny',
  small: 'NewModal--small',
  fixed: 'NewModal--fixed',
  informative: 'NewModal--informative',
};

export default mapping;
